import { render, staticRenderFns } from "./OtherBenefitPlans.vue?vue&type=template&id=8020af46&"
import script from "./OtherBenefitPlans.vue?vue&type=script&lang=js&"
export * from "./OtherBenefitPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports